export default __webpack_public_path__ + "static/media/eye_open.00d1658c.svg";